import { Injectable }     from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot }    from '@angular/router';
import { AuthService } from './auth.service';
import { AppHelperService } from './app-helper.service';

@Injectable()
export class AuthenticatedRoutesGuard  {
    
    constructor(
        private authService: AuthService, 
        private appHelperService: AppHelperService
    ){}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) : boolean | Promise<boolean> {
        // Return true in case of builder preview URL
        if(window.location.pathname == '/learning-path/teacher/preview' || window.location.href.indexOf('?preview=true') !== -1) {
            return true;
        }

        return this.authService.getUserDataFromSession().then(userData => {
            return this.authService.checkGigyaAndServerSession().then(()=> {
                if(userData) {
                    if(userData.role == 'student') {
                        this.appHelperService.navigateToDashboardApp([]);
                        return false;
                    } else {
                        return true;
                    } 
                } else {
                    this.authService.rurl = window.location.pathname + window.location.search;
                    return false;
                }
            })
        })
    }
}
